import { render, staticRenderFns } from "./GridPriority.vue?vue&type=template&id=2c10f5e0&"
import script from "./GridPriority.ts?vue&type=script&lang=js&"
export * from "./GridPriority.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports